import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/AdminPages.css';

const InvestorEarnxpPage = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://api.tannit.uk/Ecovest/earnxp/1');
        const result = await response.json();
        
        if (result?.status?.code === 1 && result?.data) {
          const earnXpData = result.data[0] || result.data || [];
          setData(Array.isArray(earnXpData) ? earnXpData : []);
        } else {
          setData([]);
        }
        setError(null);
      } catch (err) {
        console.error('Failed to fetch earn XP data:', err);
        setError('Failed to load earn XP data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <button 
            onClick={() => navigate(-1)} 
            style={{
              background: '#f1f5f9',
              border: 'none',
              borderRadius: '8px',
              padding: '10px 15px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: '#475569',
              fontWeight: '500',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.background = '#e2e8f0'}
            onMouseOut={(e) => e.currentTarget.style.background = '#f1f5f9'}
          >
            <span style={{ fontSize: '16px' }}>←</span> Back
          </button>
          <div>
            <h1>Earn XP Objectives</h1>
            <p>XP earning opportunities from Ecovest</p>
          </div>
        </div>
      </div>

      <div className="admin-table-card">
        {error && (
          <div className="admin-form-error" style={{ margin: '20px', borderRadius: '8px' }}>
            {error}
          </div>
        )}
        
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Description</th>
              <th>XP Reward</th>
              <th>Objective</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="admin-loading-row">
                <td colSpan="5">
                  <div className="admin-table-loading">
                    <div className="admin-spinner"></div>
                    <span>Loading...</span>
                  </div>
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan="5" className="admin-empty">
                  No earn XP objectives found
                </td>
              </tr>
            ) : (
              data.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td><strong>{item.title}</strong></td>
                  <td style={{ maxWidth: '400px' }}>{item.descriptionXp}</td>
                  <td>
                    <span className="badge bg-primary">{item.xp.toLocaleString()} XP</span>
                  </td>
                  <td>{item.objective}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvestorEarnxpPage;
